import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container',
    content: 'mt-12 grid gap-2 md:mt-16 md:grid-cols-3 md:gap-5',
    info: 'bg-white px-3.5 py-6',
    title: 'mb-2 text-xl leading-[140%] font-medium',
    address: 'mb-3 text-xs leading-[140%]',
    phone:
      'border-b-bg-items-black border-b-1 text-xs leading-[140%] hover:opacity-70'
  }
});
